import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import React, { useState, useEffect } from "react";

const SelectCfdi = ({ detectarCambiosCfdi, addresses }) => {
  const options = [
    { value: "G01", label: "G01 - Adquisición de mercancías" },
    { value: "P01", label: "P01 - Por definir" },
    { value: "G03", label: "G03 - Gastos en general" },
  ];

  const [selectedCfdi, setSelectedCfdi] = useState("");

  useEffect(() => {
    const initialOption = options.find((option) => option.value === addresses);
    if (initialOption) {
      setSelectedCfdi(initialOption.value);
      detectarCambiosCfdi(initialOption.value);
    }
  }, [addresses]);

  const handleCfdiChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedCfdi(selectedValue);
    detectarCambiosCfdi(selectedValue);
  };

  return (
    <FormControl fullWidth>
      <InputLabel id="cfdi-select-label">Selecciona el CFDI</InputLabel>
      <Select
        labelId="cfdi-select-label"
        id="cfdi-select"
        value={selectedCfdi}
        onChange={handleCfdiChange}
        label="Selecciona el CFDI"
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectCfdi;
